import styled from 'styled-components'

const Wrapper = styled.div`
  margin-top: 16px;
  min-height: 29px;
`
export { Wrapper }
